import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react'
import Banner, { BANNER_VARIANTS } from '@adsk/alloy-react-banner'
import { type CSSProp } from 'styled-components'

export interface BannerRef {
	showBanner: (message?: React.ReactNode) => void
	hideBanner: () => void
	getCurrentState: () => boolean
}

interface AlertBannerProps {
	message?: React.ReactNode
	open?: boolean
	variant?: string
	props?: object
	style?: CSSProp<any>
	onClose?: () => void
	ref?: React.Ref<BannerRef>
}
const AlertBanner = forwardRef<BannerRef, AlertBannerProps>(
	({ message, variant, onClose, props, style, open }, ref): JSX.Element => {
		const bannerRef = useRef<HTMLInputElement>(null)
		const [bannerMessage, setBannerMessage] = useState<
			React.ReactNode | undefined
		>(message)
		const [isOpen, setOpen] = useState<boolean>(open ?? false)
		useImperativeHandle(ref, () => ({
			showBanner: (message?: React.ReactNode): void => {
				setOpen(true)
				if (message !== undefined) {
					setBannerMessage(message)
				}
			},
			hideBanner: (): void => {
				setOpen(false)
			},
			getCurrentState: (): boolean => {
				return isOpen
			},
		}))

		return isOpen ? (
			<Banner
				message={bannerMessage}
				data-testid={'bannerTestId'}
				ref={bannerRef}
				variant={variant ?? BANNER_VARIANTS.WARNING}
				open={isOpen}
				style={style}
				{...props}
			/>
		) : (
			<></>
		)
	}
)
AlertBanner.displayName = 'AlertBannerComponent'
export default AlertBanner
